import { render, staticRenderFns } from "./ProcessingBatchBulkImportTab.vue?vue&type=template&id=71bdd58f&scoped=true"
import script from "./ProcessingBatchBulkImportTab.vue?vue&type=script&lang=js"
export * from "./ProcessingBatchBulkImportTab.vue?vue&type=script&lang=js"
import style0 from "./ProcessingBatchBulkImportTab.vue?vue&type=style&index=0&id=71bdd58f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdd58f",
  null
  
)

export default component.exports